// Copyright (c) 2026 embyt GmbH. All rights reserved.
// Author: Marc Planeck <office@planeck.at>
import { TrendMonitor as ITrendMonitor } from "shared/types/cloudtypes";

class TrendMonitorModel {
  public static getActiveSortedTrendMonitorIdxs(trendMonitors: ITrendMonitor[]): number[] {
    const idxs = Array.from(Array(trendMonitors.length).keys())
      .filter((curIdx) => trendMonitors[curIdx].isActive)
      .sort((a, b) => trendMonitors[a].title.localeCompare(trendMonitors[b].title));
    return idxs;
  }
}

export default TrendMonitorModel;
